
// eslint-disable-next-line import/prefer-default-export
export const b64ToUtf8 = (str) => decodeURIComponent(escape(window.atob(str)));
